export default __webpack_public_path__ + "static/media/image.adage-consulting-pvt-ltd.e6e9bb44.png";